module.exports = __webpack_public_path__ + "static/media/home.3b3b8388.png";